import { render, staticRenderFns } from "./MemberSettings.vue?vue&type=template&id=13f90650&scoped=true&"
import script from "./MemberSettings.vue?vue&type=script&lang=js&"
export * from "./MemberSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f90650",
  null
  
)

export default component.exports